import React from 'react';
import { useTranslation } from 'react-i18next';
import MacBookOutline from '/src/images/home/macbook-outline.svg';
import IPhoneOutline from '/src/images/home/iphone-outline.svg';
import IPhoneOutlineLandscape from '/src/images/home/iphone-outline-landscape.svg';

const ExploreDriverCloud = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.explore-driver-cloud' });

	return (
		<section id="explore-driver-cloud">
			<div>
				<h1>{t('record-vehicle')}</h1>
				<h1>{t('access-data')}</h1>

				<div className="live-view-container">
					<div className="inner-wrapper">
						<iframe src="https://cloud.drivertechnologies.com/shared?token=3180ea4d-391b-40bb-926f-06bcf1b5aee2&t=00:03" />
						<img
							src={MacBookOutline}
							className="media-border desktop-screen"
							alt={t('driver-cloud-app')}
						/>
						<img
							src={IPhoneOutline}
							className="media-border mobile-screen"
							alt={t('driver-cloud-app')}
						/>
						<img
							src={IPhoneOutlineLandscape}
							className="media-border mobile-screen-landscape"
							alt={t('driver-cloud-app')}
						/>
					</div>
				</div>

				<h4 className="bold">{t('driver-with')}</h4>
				<p>{t('sharing-a-video-2')}</p>

				{/* <button>{t('learn-more-about')}</button> */}
			</div>
		</section>
	);
};

export default ExploreDriverCloud;
